<template>
  <div id="tac-admin-dropship-sync-product__dashboard">
    <ol class="breadcrumb">
      <li><a href="/admin">Admin</a></li>
      <li><a href="/admin/dropship">Dashboard</a></li>
      <li><a href="/admin/dropship/seller">Seller</a></li>
      <li><router-link :to="{name: 'admin/dropship/seller/sync/dashboard'}">Sync</router-link></li>
      <li class="active">Product</li>
    </ol>
    <div class="page-header">
      <h1 class="page-header-title">
        <span class="fa fa-fw fa-exchange"></span>
        Product Sync <small>Pull from supplier</small>
      </h1>
    </div><!-- .page-header -->
    <div class="page-body">
      <div class="row">
        <div class="col-lg-6">
          <by-product-form></by-product-form>
          <by-manual-form></by-manual-form>
          <pull-components-form></pull-components-form>
        </div>
        <div class="col-lg-6">
          <by-image-form></by-image-form>
        </div>
      </div>
    </div><!-- .page-body -->
  </div><!-- #tac-admin-dropship-sync-product__dashboard -->
</template>

<script>
import ByManualForm from './ByManualForm'
import ByProductForm from './ByProductForm'
import ByImageForm from './ByImageForm'
import PullComponentsForm from './PullComponentsForm'

export default {
  created() {
    this.fetchOptions()
  },
  methods: {
    fetchOptions() {
      this.$store.dispatch('dropship/seller/syncProduct/fetchOptions')
    }
  },
  components: {
    ByManualForm,
    ByProductForm,
    ByImageForm,
    PullComponentsForm
  }
}
</script>
